// Google Analytics 4 page-view tracking for the SPA.
// gtag.js is loaded and configured in public/index.html with
// send_page_view:false, so we send a page_view manually on each route change.

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/** Send a page_view event for a client-side navigation. */
export function trackPageView(path: string): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
